import { styled } from '@abyss/web/tools/styled';
import { Text } from '@abyss/web/ui/Text';

export const TruncatedTextStyled = styled(Text, {
  '&.abyss-text-root': {
    display: 'block',
    width: '100%',
    minWidth: 0,
  },
  dynamic: ({ cssProps: { removeTruncatedDataCard } }) => ({
    overflow: removeTruncatedDataCard ? 'visible' : 'hidden',
    textOverflow: removeTruncatedDataCard ? 'unset' : 'ellipsis',
    textWrap: removeTruncatedDataCard ? 'wrap' : 'nowrap',
    whiteSpace: removeTruncatedDataCard ? 'normal' : 'nowrap',
  }),
});
